import {Controller} from "@/controllers/Controller";

/**
 * Controller for topic API (ms-marketing) : les sujets de contenu
 */
export class TopicController extends Controller {

    // Tous les sujets du groupe, chacun avec le résumé de ses publications (la liste complète d'un groupe reste petite)
    static getTable() {
        return this.requestBuilder("GET", `/marketing/topics/table`, true);
    }

    // Un sujet avec ses publications
    static get(id) {
        return this.requestBuilder("GET", `/marketing/topics/${id}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/marketing/topics`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/marketing/topics/${id}`, true, body);
    }

    // Supprime le sujet et ses publications
    static delete(id) {
        return this.requestBuilder("PATCH", `/marketing/topics/deactivate/${id}`, true);
    }
}
